import { useEffect, useState } from "react";
import Loading, { LoadingBall } from "@ingka/loading";
import SSRIcon from "@ingka/ssr-icon";
import pathWifiOff from "@ingka/ssr-icon/paths/wifi-strikethrough";
import { onConnectionChange } from "../api/connectionStatus";
import styles from "./ConnectionOverlay.module.css";

export function ConnectionOverlay() {
    const [unreachable, setUnreachable] = useState(false);

    useEffect(() => onConnectionChange(setUnreachable), []);

    if (!unreachable) return null;

    return (
        <div className={styles.overlay}>
            <div className={styles.card}>
                <SSRIcon paths={pathWifiOff} className={styles.icon} />
                <h2 className={styles.title}>Server unreachable</h2>
                <p className={styles.message}>
                    Cannot connect to the backend server.
                    <br />
                    Make sure it's running and try again.
                </p>
                <Loading text="Retrying automatically…">
                    <LoadingBall size="small" />
                </Loading>
            </div>
        </div>
    );
}
